export default __webpack_public_path__ + "static/media/vid2.46b26a41.mp4";